export default __webpack_public_path__ + "static/media/touch_node_and_get_scared.722a1630.png";